import { sumBy } from 'lodash';

type MinShareholderType = {
  numberShares: number;
};

export const sumTotalShares = <T extends MinShareholderType>(
  shareholders: T[],
) => sumBy(shareholders, (x) => nonNegative(x.numberShares));

export const nonNegative = (x?: number) => {
  // Coerce behavior is desired here
  // eslint-disable-next-line no-restricted-globals
  if (!x || isNaN(x)) {
    return 0;
  }

  return Math.max(x, 0);
};
